import { render, staticRenderFns } from "./VideoRoomEnterInfo.vue?vue&type=template&id=2afb18a5&scoped=true&"
import script from "./VideoRoomEnterInfo.vue?vue&type=script&lang=js&"
export * from "./VideoRoomEnterInfo.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomEnterInfo.vue?vue&type=style&index=0&id=2afb18a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb18a5",
  null
  
)

export default component.exports